// import React, { useEffect, useState } from 'react';
// // import PaymentServices from '../services/PaymentServices'; // Adjust path as needed
// import PaymentServices from '../../services/externalServices/TicketServices/paymentServicesV2';
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import CompanyDetailServices from '../../services/externalServices/companyServices';
// // import { formatToIST } from "../utils/dateFormater";
// import * as XLSX from "xlsx";
// // import  UploadBankStatement from '../../Payment/UploadBankStatement'
// import UploadTicketStatement from '../../Payment/UploadTicketStatement';


// const RevenueReport = () => {
//     const [data, setData] = useState([]);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [filteredData, setFilteredData] = useState([]);
//     const [filters, setFilters] = useState({
//         paymentMode: 'all',
//         transactionStatus: 'all',
//         dateRange: 'all',
//         startDate: '',
//         endDate: ''
//     });

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
//     const isTicketAdmin = role === 'ticket-admin';
//     const theatreName1 = accessList?.[0];




//     // For the bank addition

//     const [currentPage, setCurrentPage] = useState(1);
//     const rowsPerPage = 100;

//     const totalPages = Math.ceil(filteredData.length / rowsPerPage);
//     const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);



//     const [selectedBank, setSelectedBank] = useState("Select Bank");
//     const [banks, setBanks] = useState([]);
//     const [showBankSelector, setShowBankSelector] = useState(false);

//     const [matchedTransactions, setMatchedTransactions] = useState([]);
//     const [showMatchedOnly, setShowMatchedOnly] = useState(false);

//     // Add to fecth theatre account
//     const [theatreAccounts, setTheatreAccounts] = useState([]);
//     const [selectedTheatreAccount, setSelectedTheatreAccount] = useState(null);

//     // Fetch theatre accounts
//     useEffect(() => {
//         const fetchTheatreAccounts = async () => {
//             try {
//                 const response = await PaymentServices.getTheatreAccounts();

//                 console.log('response of the account==', response);
//                 setTheatreAccounts(response);
//             } catch (error) {
//                 console.error("Error fetching theatre accounts:", error);
//             }
//         };
//         fetchTheatreAccounts();
//     }, []);

//     const handleGenerateClick = () => {
//         setShowBankSelector(true);
//     };

//     const handleBankChange = (event) => {
//         setSelectedBank(event.target.value);
//     };

//     const handleGenerateFile = () => {
//         if (!selectedBank || selectedBank === "Select Bank") {
//             alert("Please select a bank to proceed.");
//             return;
//         }
//         generateExcel();
//         setShowBankSelector(false);
//     };


//     useEffect(() => {
//         getBankDetails();
//     }, [])

//     const formatToIST = (dateString) => {
//         const date = new Date(dateString);
//         return date.toLocaleString('en-IN', {
//             timeZone: 'Asia/Kolkata',
//             day: '2-digit',
//             month: '2-digit',
//             year: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//             second: '2-digit'
//         });
//     };


    
//     const generateExcel = () => {
//         try {
//             const selectedBankDetails = banks.find(
//                 (bank) => bank.bankName === selectedBank
//             );

//             if (!selectedBankDetails) {
//                 alert("Please select a valid bank.");
//                 return;
//             }

//             const bankDetails = {
//                 "Bank Name": selectedBankDetails.bankName,
//                 "Account Number": selectedBankDetails.accountNumber,
//                 "IFSC Code": selectedBankDetails.ifscCode,
//                 "Account Type": selectedBankDetails.accountType,
//             };

//             // Get theatre details - use selected beneficiary or fallback to first booking
//             const theatreDetails = selectedTheatreAccount || filteredData[0] || {};
//             const theatreName = selectedTheatreAccount?.theatreName ||
//                 theatreDetails.theatreName ||
//                 "Theatre Name Not Available";

//             // Prepare base data
//             const data = filteredData.map((booking) => ({
//                 Date: formatToIST(booking.bookingDate),
//                 BookingId: booking.bookingId,
//                 Amount: booking.theatrePayable || 0,
//                 PaymentMode: booking.paymentMode || "N/A",
//                 TransactionStatus: booking.transactionStatus || "N/A",
//                 TransactionId: booking.transactionId || "N/A",
//                 TheatreName: theatreName,
//                 TheatrePayable: booking.theatrePayable || 0,
//                 TheatreBaseAmount: booking.theatreBaseAmount || 0,
//                 TheatreGstAmount: booking.theatreGstAmount || 0,
//             }));

//             let formattedData;
//             let headers;

//             // ICICI Bank Format
//             if (selectedBank === "ICICI Bank") {
//                 formattedData = data.map((item) => ({
//                     "Transaction Date": item.Date,
//                     "Transaction Ref No": item.BookingId,
//                     "Amount In INR": item.TheatrePayable,
//                     "Payment State": item.TransactionStatus,
//                     "Theatre Name": item.TheatreName,
//                     "Payment Mode": item.PaymentMode,
//                     "Transaction ID": item.TransactionId,
//                     "Base Amount": item.TheatreBaseAmount,
//                     "GST Amount": item.TheatreGstAmount,
//                     "Bank Name": bankDetails["Bank Name"],
//                     "Account Number": bankDetails["Account Number"],
//                     "IFSC Code": bankDetails["IFSC Code"],
//                     "Account Type": bankDetails["Account Type"],
//                     // Add beneficiary details if available
//                     ...(selectedTheatreAccount ? {
//                         "Beneficiary Name": selectedTheatreAccount.beneficiaryName,
//                         "Beneficiary Account": selectedTheatreAccount.accountNumber,
//                         "Beneficiary IFSC": selectedTheatreAccount.ifscCode,
//                         "Beneficiary Bank": selectedTheatreAccount.bankName
//                     } : {})
//                 }));

//                 headers = [
//                     "Transaction Date",
//                     "Transaction Ref No",
//                     "Amount In INR",
//                     "Payment State",
//                     "Theatre Name",
//                     "Payment Mode",
//                     "Transaction ID",
//                     "Base Amount",
//                     "GST Amount",
//                     "Bank Name",
//                     "Account Number",
//                     "IFSC Code",
//                     "Account Type",
//                     // Conditionally add beneficiary headers
//                     ...(selectedTheatreAccount ? [
//                         "Beneficiary Name",
//                         "Beneficiary Account",
//                         "Beneficiary IFSC",
//                         "Beneficiary Bank"
//                     ] : [])
//                 ];
//             }
//             // Ujjivan Bank Format
//             else if (selectedBank === "Ujjivan Bank") {
//                 formattedData = data.map((item) => ({
//                     Identifier: "NFT",
//                     "Unique reference number": item.BookingId,
//                     Amount: item.TheatrePayable,
//                     "Debit Account number": bankDetails["Account Number"],
//                     "Beneficiary Name": selectedTheatreAccount?.beneficiaryName || theatreName,
//                     "Beneficiary Address": "",
//                     "Beneficiary Account number": selectedTheatreAccount?.accountNumber || bankDetails["Account Number"],
//                     "Beneficiary Bank IFSC code": selectedTheatreAccount?.ifscCode || bankDetails["IFSC Code"],
//                     "Beneficiary Bank Name": selectedTheatreAccount?.bankName || bankDetails["Bank Name"],
//                     Remarks: "",
//                     LEI: "",
//                 }));

//                 headers = [
//                     "Identifier",
//                     "Unique reference number",
//                     "Amount",
//                     "Debit Account number",
//                     "Beneficiary Name",
//                     "Beneficiary Address",
//                     "Beneficiary Account number",
//                     "Beneficiary Bank IFSC code",
//                     "Beneficiary Bank Name",
//                     "Remarks",
//                     "LEI",
//                 ];
//             }

//             // Rest of the Excel generation code remains the same...
//             const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

//             // Set column widths
//             const colWidths = headers.map((header) => {
//                 let maxLength = header.length;
//                 formattedData.forEach((item) => {
//                     const cellLength = (item[header] || "").toString().length;
//                     if (cellLength > maxLength) maxLength = cellLength;
//                 });
//                 return { wch: maxLength + 2 };
//             });

//             ws["!cols"] = colWidths;

//             // Style headers
//             headers.forEach((header, index) => {
//                 const cell = ws[XLSX.utils.encode_cell({ r: 0, c: index })];
//                 if (cell) {
//                     cell.s = {
//                         font: {
//                             bold: true,
//                             sz: 12,
//                             color: { rgb: "FFFFFF" },
//                         },
//                         fill: { fgColor: { rgb: "4F81BD" } },
//                     };
//                 }
//             });

//             const wb = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(wb, ws, `${selectedBank}_TheatrePayments`);
//             XLSX.writeFile(wb, `${selectedBank}_TheatrePayments_${new Date().toISOString().split('T')[0]}.xlsx`);

//         } catch (error) {
//             console.error("Error generating Excel file:", error);
//             alert("Error generating Excel file. Please try again.");
//         }
//     };


//     const getBankDetails = async () => {
//         try {
//             const res = await CompanyDetailServices.getCompanyDetails();
//             console.log("getBankDetails", res);
//             // Assuming res contains the company details and bankDetails is part of it
//             const bankDetails = res[0]?.bankDetails || [];
//             console.log("bankDetails", bankDetails);

//             setBanks(bankDetails);
//         } catch (error) {
//             console.log("error while getting the company details", error);
//         }
//     };




//     const handleTicketTransactionsExtracted = (transactionsFromFile) => {
//         // Find matches in our FILTERED data (not complete data)
//         const matches = filteredData.filter(existingItem => {
//             const existingTransactionId = existingItem.transactionId?.toString();

//             // Check if this transaction exists in the uploaded file
//             return transactionsFromFile.some(fileItem => {
//                 // Check against all possible reference fields in the file
//                 return (
//                     existingTransactionId === fileItem['Merchant Reference Id']?.toString() ||
//                     existingTransactionId === fileItem['PhonePe Reference Id']?.toString() ||
//                     existingTransactionId === fileItem['PhonePe Transaction Reference Id']?.toString() ||
//                     existingTransactionId === fileItem['PhonePe Attempt Reference Id']?.toString() ||
//                     existingTransactionId === fileItem['Merchant Order Id']?.toString()
//                 );
//             });
//         });

//         setMatchedTransactions(matches);
//         setShowMatchedOnly(true);
//         setFilteredData(matches);

//         // Show match count
//         alert(`Found ${matches.length} matching transactions within the current filters`);
//     };

//     const toggleShowMatchedOnly = () => {
//         setShowMatchedOnly(!showMatchedOnly);
//         if (!showMatchedOnly) {
//             setFilteredData(matchedTransactions);
//         } else {
//             applyFilters(); // Reset to show all filtered data
//         }
//     };



//     // Get unique payment modes from data
//     const getPaymentModes = (data) => {
//         const modes = new Set();
//         data.forEach(item => {
//             if (item.paymentMode) {
//                 modes.add(item.paymentMode);
//             }
//         });
//         return Array.from(modes).map(mode => ({
//             value: mode,
//             label: mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase()
//         }));
//     };

//     // Get unique statuses from data
//     const getStatusOptions = (data) => {
//         const statuses = new Set();
//         data.forEach(item => {
//             if (item.transactionStatus) {
//                 statuses.add(item.transactionStatus);
//             }
//         });
//         return Array.from(statuses).map(status => ({
//             value: status,
//             label: status
//         }));
//     };

//     const [paymentModes, setPaymentModes] = useState([
//         { value: 'all', label: 'All Payment Modes' }
//     ]);

//     const [statusOptions, setStatusOptions] = useState([
//         { value: 'all', label: 'All Statuses' }
//     ]);

//     // Apply filters
//     const applyFilters = () => {
//         let result = [...data];

//         // Payment mode filter
//         if (filters.paymentMode !== 'all') {
//             result = result.filter(item => item.paymentMode === filters.paymentMode);
//         }

//         // Status filter
//         if (filters.transactionStatus !== 'all') {
//             result = result.filter(item => item.transactionStatus === filters.transactionStatus);
//         }

//         // Date range filter
//         if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
//             result = result.filter(item => {
//                 const bookingDate = new Date(item.bookingDate);
//                 const startDate = new Date(filters.startDate);
//                 startDate.setHours(0, 0, 0, 0); // Start of the day (00:00:00.000)
//                 const endDate = new Date(filters.endDate);
//                 endDate.setHours(23, 59, 59, 999); // End of the day (23:59:59.999)
//                 return bookingDate >= startDate && bookingDate <= endDate;
//             });
//         } else if (filters.dateRange !== 'all') {
//             const now = new Date();
//             let startDate = new Date();

//             switch (filters.dateRange) {
//                 case 'today':
//                     startDate.setHours(0, 0, 0, 0);
//                     break;
//                 case 'week':
//                     startDate.setDate(now.getDate() - 7);
//                     break;
//                 case 'month':
//                     startDate.setMonth(now.getMonth() - 1);
//                     break;
//                 default:
//                     break;
//             }

//             result = result.filter(item => {
//                 const bookingDate = new Date(item.bookingDate);
//                 return bookingDate >= startDate;
//             });
//         }

//         setFilteredData(result);
//     };

//     useEffect(() => {
//         console.log('in the file of the Revenue reports');
//         const fetchRevenueReport = async () => {
//             try {
//                 const theatreName = theatreName1;
//                 const response = await PaymentServices.getRevenueReportWithSplit(theatreName);
//                 console.log('response in the fetchRevenue report', response.data);
//                 const result = response;
//                 setData(result.data || []);
//                 setFilteredData(result.data || []);

//                 // Update payment modes and status options from data
//                 const modesFromData = getPaymentModes(result.data || []);
//                 setPaymentModes([
//                     { value: 'all', label: 'All Payment Modes' },
//                     ...modesFromData
//                 ]);

//                 const statusesFromData = getStatusOptions(result.data || []);
//                 setStatusOptions([
//                     { value: 'all', label: 'All Statuses' },
//                     ...statusesFromData
//                 ]);
//             } catch (err) {
//                 setError('Failed to load revenue report');
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchRevenueReport();
//     }, []);

//     // Apply filters when filters change
//     useEffect(() => {
//         applyFilters();
//     }, [filters, data]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     if (isLoading) return <div className="text-center py-8">Loading report...</div>;
//     if (error) return <div className="text-center py-8 text-red-500">{error}</div>;

//     const totals = filteredData.reduce((acc, item) => ({
//         totalAmount: acc.totalAmount + item.totalAmount,
//         theatrePayable: acc.theatrePayable + item.theatrePayable,
//         platformEarnings: acc.platformEarnings + item.platformEarnings,
//         count: acc.count + 1
//     }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });






//     return (
//         // <div className="w-full overflow-x-hidden"> {/* Add this wrapper */}
//         <div className="w-full max-w-[100vw] overflow-x-hidden">
//         <div className="container mx-auto px-4 py-6">
//             {/* Header Section */}
//             <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
//                 <div>
//                     <h1 className="text-2xl font-bold text-gray-800">Revenue Report</h1>
//                     {showMatchedOnly && (
//                         <div className="bg-blue-50 p-3 rounded-md mb-4 flex items-center justify-between">
//                             <div className="text-sm text-blue-700">
//                                 Showing {matchedTransactions.length} transactions matched from uploaded file
//                             </div>
//                             <button
//                                 onClick={() => setShowMatchedOnly(false)}
//                                 className="text-blue-600 hover:text-blue-800 text-sm font-medium"
//                             >
//                                 Clear Matches
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 <div className="flex items-center space-x-3 mt-3 md:mt-0">
//                     <button
//                         onClick={toggleShowMatchedOnly}
//                         className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${showMatchedOnly
//                             ? 'bg-green-600 text-white hover:bg-green-700'
//                             : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
//                             }`}
//                     >
//                         {showMatchedOnly ? 'Show All' : 'Show Matched Only'}
//                     </button>
//                 </div>
//             </div>

//             {/* Main Card */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-100  mb-6 ">
//                 {/* Filters Section */}
//                 <div className="p-6 border-b border-gray-100 w-full">
//                     <div className="flex flex-col md:flex-row gap-6">
//                         {/* Filters Column */}
//                         <div className="flex-1">
//                             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
//                                 {/* Date Range Group */}
//                                 <div className="md:col-span-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
//                                     <div className="flex justify-between items-center mb-2">
//                                         <h3 className="text-sm font-medium text-gray-700">Date Range</h3>
//                                         <button
//                                             onClick={() => {
//                                                 setFilters({
//                                                     paymentMode: 'all',
//                                                     transactionStatus: 'all',
//                                                     dateRange: 'all',
//                                                     startDate: '',
//                                                     endDate: ''
//                                                 });
//                                             }}
//                                             className="text-xs text-red-600 hover:text-red-800"
//                                         >
//                                             Clear Filters
//                                         </button>
//                                     </div>

//                                     <div className="grid grid-cols-1 gap-3">
//                                         <select
//                                             name="dateRange"
//                                             value={filters.dateRange}
//                                             onChange={handleFilterChange}
//                                             className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                         >
//                                             <option value="all">All Time</option>
//                                             <option value="today">Today</option>
//                                             <option value="week">Last 7 Days</option>
//                                             <option value="month">Last 30 Days</option>
//                                             <option value="custom">Custom Range</option>
//                                         </select>

//                                         {/* Custom Dates */}
//                                         {filters.dateRange === 'custom' && (
//                                             <div className="grid grid-cols-2 gap-3">
//                                                 <div>
//                                                     <label className="block text-xs text-gray-500 mb-1">Start Date</label>
//                                                     <input
//                                                         type="date"
//                                                         name="startDate"
//                                                         value={filters.startDate}
//                                                         onChange={handleFilterChange}
//                                                         className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                     />
//                                                 </div>
//                                                 <div>
//                                                     <label className="block text-xs text-gray-500 mb-1">End Date</label>
//                                                     <input
//                                                         type="date"
//                                                         name="endDate"
//                                                         value={filters.endDate}
//                                                         onChange={handleFilterChange}
//                                                         className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}

//                                         {/* Generate File Section */}


//                                         <div className="mt-2">
//                                             {!showBankSelector ? (
//                                                 <button
//                                                     className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
//                                                     onClick={handleGenerateClick}
//                                                 >
//                                                     Generate Bank File
//                                                 </button>
//                                             ) : (
//                                                 <div className="flex flex-col gap-3 bg-blue-50 p-3 rounded-lg">
//                                                     <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                                                         <div>
//                                                             <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                                 Payout Bank
//                                                             </label>
//                                                             <select
//                                                                 value={selectedBank}
//                                                                 onChange={handleBankChange}
//                                                                 className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                             >
//                                                                 <option value="Select Bank">Select Bank</option>
//                                                                 {banks.map((bank) => (
//                                                                     <option key={bank.id} value={bank.bankName}>
//                                                                         {bank.bankName}
//                                                                     </option>
//                                                                 ))}
//                                                             </select>
//                                                         </div>

//                                                         <div>
//                                                             <label className="block text-sm font-medium text-gray-700 mb-1">
//                                                                 Beneficiary Account
//                                                             </label>
//                                                             <select
//                                                                 value={selectedTheatreAccount?._id || ''}
//                                                                 onChange={(e) => {
//                                                                     const account = theatreAccounts.find(acc => acc._id === e.target.value);
//                                                                     setSelectedTheatreAccount(account || null);
//                                                                 }}
//                                                                 className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                             >
//                                                                 <option value="">Select Beneficiary</option>
//                                                                 {theatreAccounts.map((account) => (
//                                                                     <option key={account._id} value={account._id}>
//                                                                         {account.theatreName} ({account.bankName})
//                                                                     </option>
//                                                                 ))}
//                                                             </select>
//                                                         </div>
//                                                     </div>

//                                                     <button
//                                                         className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
//                                                         onClick={handleGenerateFile}
//                                                         disabled={!selectedBank || selectedBank === "Select Bank"}
//                                                     >
//                                                         Generate File
//                                                     </button>
//                                                 </div>
//                                             )}
//                                         </div>

//                                         {/* <div className="mt-2">
//                                             {!showBankSelector ? (
//                                                 <button
//                                                     className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors"
//                                                     onClick={handleGenerateClick}
//                                                 >
//                                                     Generate Bank File
//                                                 </button>
//                                             ) : (
//                                                 <div className="flex items-center gap-3">
//                                                     <select
//                                                         value={selectedBank}
//                                                         onChange={handleBankChange}
//                                                         className="flex-1 p-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                                     >
//                                                         <option value="Select Bank">Select Bank</option>
//                                                         {banks.map((bank) => (
//                                                             <option key={bank.id} value={bank.bankName}>
//                                                                 {bank.bankName}
//                                                             </option>
//                                                         ))}
//                                                     </select>

//                                                     <button
//                                                         className="px-4 py-2 bg-blue-600 border border-transparent rounded-lg text-sm font-medium text-white hover:bg-blue-700 transition-colors"
//                                                         onClick={handleGenerateFile}
//                                                         disabled={!selectedBank || selectedBank === "Select Bank"}
//                                                     >
//                                                         Generate
//                                                     </button>
//                                                 </div>
//                                             )}
//                                         </div> */}
//                                     </div>
//                                 </div>

//                                 {/* Payment Mode */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">Payment Mode</label>
//                                     <select
//                                         name="paymentMode"
//                                         value={filters.paymentMode}
//                                         onChange={handleFilterChange}
//                                         className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                     >
//                                         {paymentModes.map(mode => (
//                                             <option key={mode.value} value={mode.value}>{mode.label}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Status */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
//                                     <select
//                                         name="transactionStatus"
//                                         value={filters.transactionStatus}
//                                         onChange={handleFilterChange}
//                                         className="w-full p-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//                                     >
//                                         {statusOptions.map(status => (
//                                             <option key={status.value} value={status.value}>{status.label}</option>
//                                         ))}
//                                     </select>
//                                 </div>

//                                 {/* Upload Column */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-gray-700 mb-1">Upload Statement</label>
//                                     <UploadTicketStatement onTransactionsExtracted={handleTicketTransactionsExtracted} />
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Summary Cards */}
//                 <div className="p-6 bg-gray-50 w-full">
//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
//                         <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                             <h3 className="text-gray-500 text-sm font-medium">Total Bookings</h3>
//                             <p className="text-2xl font-bold text-gray-800 mt-1">{totals.count}</p>
//                         </div>
//                         <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                             <h3 className="text-gray-500 text-sm font-medium">Total Revenue</h3>
//                             <p className="text-2xl font-bold text-gray-800 mt-1">₹{totals.totalAmount.toFixed(2)}</p>
//                         </div>
//                         <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                             <h3 className="text-gray-500 text-sm font-medium">Theatre Payable</h3>
//                             <p className="text-2xl font-bold text-gray-800 mt-1">₹{totals.theatrePayable.toFixed(2)}</p>
//                         </div>
//                         <div className="bg-white p-4 rounded-lg shadow-xs border border-gray-100">
//                             <h3 className="text-gray-500 text-sm font-medium">Platform Earnings</h3>
//                             <p className="text-2xl font-bold text-gray-800 mt-1">₹{totals.platformEarnings.toFixed(2)}</p>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Data Table */}
//             <div className="bg-white rounded-xl shadow-sm border border-gray-100 ">
//                 <div className="overflow-x-auto ">
//                     {/* <div className="max-h-[calc(100vh-400px)] overflow-y-auto"> */}
//                     {/* <div className="overflow-y-auto max-h-[calc(100vh-200px)]"> */}
//                     <div className="overflow-y-auto">

//                         <table className="w-full divide-y divide-gray-200">
//                             <thead className="bg-gray-50 sticky top-0">
//                                 <tr>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Booking ID</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Movie</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Theatre</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Date</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Show Time</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transaction ID</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatreBaseAmount</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatreGstAmount</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">theatrePayable</th>

//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformFee</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformGst</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">gatewayCharges</th>
//                                     <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">platformEarnings</th>
//                                     {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th> */}
//                                 </tr>
//                             </thead>
//                             <tbody className="bg-white divide-y divide-gray-200">
//                                 {/* {filteredData.map((booking) => ( */}
//                                 {paginatedData.map((booking) => (

//                                     <tr key={booking._id} className="hover:bg-gray-50">
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
//                                             {booking.bookingId}
//                                         </td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">{booking.movieName}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 max-w-xs truncate">{booking.theatreName}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{booking.showDate}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{booking.showTime}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono">{booking.transactionId}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.totalAmount}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap">
//                                             <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
//                             ${booking.transactionStatus === 'Success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
//                                                 {booking.transactionStatus}
//                                             </span>
//                                         </td>
//                                         {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                             <button className="text-blue-600 hover:text-blue-800">View</button>
//                                         </td> */}

//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.theatreBaseAmount}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.theatreGstAmount}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.theatrePayable}</td>

//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.platformFee}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.platformGst}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.gatewayCharges}</td>
//                                         <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-medium">₹{booking.platformEarnings}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>

//             <div className="flex justify-between items-center p-4">
//                 <button
//                     className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//                     onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
//                     disabled={currentPage === 1}
//                 >
//                     Prev
//                 </button>

//                 <span className="text-sm text-gray-700">
//                     Page {currentPage} of {totalPages}
//                 </span>

//                 <button
//                     className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
//                     onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
//                     disabled={currentPage === totalPages}
//                 >
//                     Next
//                 </button>
//             </div>


//             {/* Print Button */}
//             <div className="mt-6 flex justify-end">
//                 <button className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors">
//                     Print Report
//                 </button>
//             </div>
//         </div>
//         </div>
//     );
// };






// export default RevenueReport;









// Fully modularized and beautified version of RevenueReport
import React, { useEffect, useState } from 'react';
import PaymentServices from '../../services/externalServices/TicketServices/paymentServicesV2';
import CompanyDetailServices from '../../services/externalServices/companyServices';
import UploadTicketStatement from '../../Payment/UploadTicketStatement';
// import { calculateRevenueTotals } from './components/calculateRevenueTotals';
// import { calculateRevenueTotals } from './components/calculateRevenueTotals ';
import { calculateRevenueTotals } from './components/calculateRevenueTotals';

import  RevenueFilters  from './components/RevenueFilters';
import {RevenueSummaryCards} from './components/RevenueSummaryCard';
import {RevenueTable} from './components/RevenueTable';
import {PaginationControls} from './components/PaginationControls';
import {BankExportForm} from './components/BankExportForm';
import * as XLSX from "xlsx";
import moment from 'moment';

const RevenueReport = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState({
    paymentMode: 'all',
    transactionStatus: 'all',
    dateRange: 'today',
    startDate: '',
    endDate: '',
    theatreName: 'all' // <-- New
  });
  const [selectedBank, setSelectedBank] = useState("Select Bank");
  const [banks, setBanks] = useState([]);
  const [showBankSelector, setShowBankSelector] = useState(false);
  const [matchedTransactions, setMatchedTransactions] = useState([]);
  const [showMatchedOnly, setShowMatchedOnly] = useState(false);
  const [theatreAccounts, setTheatreAccounts] = useState([]);
  const [selectedTheatreAccount, setSelectedTheatreAccount] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 100;
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const [originalData, setOriginalData] = useState([]);
  const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin"));
  const theatreName1 = accessList?.[0];





  useEffect(() => {
    const fetchTheatreAccounts = async () => {
      try {
        const response = await PaymentServices.getTheatreAccounts();
        console.log('theatre details==========', response)
        setTheatreAccounts(response);
      } catch (error) {
        console.error("Error fetching theatre accounts:", error);
      }
    };
    fetchTheatreAccounts();
  }, []);

  const getTheatreOptions = (data) => {
    const names = new Set();
    data.forEach(item => {
      if (item.theatreName) {
        names.add(item.theatreName);
      }
    });
    return Array.from(names).map(name => ({
      value: name,
      label: name
    }));
  };
  const getPaymentModeOptions = (data) => {
    const modes = new Set();
    data.forEach(item => {
      if (item.paymentMode) {
        modes.add(item.paymentMode);
      }
    });
    return Array.from(modes).map(mode => ({
      value: mode,
      label: mode
    }));
  };


  const getTransactionStatusOptions = (data) => {
    const statuses = new Set();
    data.forEach(item => {
      if (item.transactionStatus) {
        statuses.add(item.transactionStatus);
      }
    });
    return Array.from(statuses).map(status => ({
      value: status,
      label: status
    }));
  };


  
  
  

  useEffect(() => {
    const fetchRevenueReport = async () => {
      try {
        const response = await PaymentServices.getRevenueReportWithSplit(theatreName1);
        setData(response.data || []);
        setOriginalData(response.data || []);
        
        // setFilteredData(response.data || []);
        setFilteredData(data.filter(i => 
          moment(i.showDate, "YYYY/MM/DD").isSame(moment(), 'day')
        ));
        
      } catch (err) {
        setError('Failed to load revenue report');
      } finally {
        setIsLoading(false);
      }
    };
    fetchRevenueReport();
    getBankDetails();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters, data]);

  const formatToIST = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const getBankDetails = async () => {
    try {
      const res = await CompanyDetailServices.getCompanyDetails();
      const bankDetails = res[0]?.bankDetails || [];
      setBanks(bankDetails);
    } catch (error) {
      console.log("error while getting the company details", error);
    }
  };

  const handleGenerateClick = () => setShowBankSelector(true);
  const handleBankChange = (event) => setSelectedBank(event.target.value);

  const handleGenerateFile = () => {
    if (!selectedBank || selectedBank === "Select Bank") {
      alert("Please select a bank to proceed.");
      return;
    }
    generateExcel();
    setShowBankSelector(false);
  };

  // const applyFilters = () => {
  //   let result = [...data];
  //   if (filters.paymentMode !== 'all') {
  //     result = result.filter(item => item.paymentMode === filters.paymentMode);
  //   }
  //   if (filters.transactionStatus !== 'all') {
  //     result = result.filter(item => item.transactionStatus === filters.transactionStatus);
  //   }
  //   if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
  //     const startDate = new Date(filters.startDate);
  //     startDate.setHours(0, 0, 0, 0);
  //     const endDate = new Date(filters.endDate);
  //     endDate.setHours(23, 59, 59, 999);
  //     result = result.filter(item => {
  //       const bookingDate = new Date(item.bookingDate);
  //       return bookingDate >= startDate && bookingDate <= endDate;
  //     });
  //   }
  //   if (filters.theatreName !== 'all') {
  //     result = result.filter(item => item.theatreName === filters.theatreName);
  //   }

  //   setFilteredData(result);
  // };


      const applyFilters = () => {
        let result = [...data];

        // Payment mode filter
        if (filters.paymentMode !== 'all') {
            result = result.filter(item => item.paymentMode === filters.paymentMode);
        }

        // Status filter
        if (filters.transactionStatus !== 'all') {
            result = result.filter(item => item.transactionStatus === filters.transactionStatus);
        }

        // Date range filter
        // if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
        //     result = result.filter(item => {
        //         const bookingDate = new Date(item.bookingDate);
        //         const startDate = new Date(filters.startDate);
        //         startDate.setHours(0, 0, 0, 0); // Start of the day (00:00:00.000)
        //         const endDate = new Date(filters.endDate);
        //         endDate.setHours(23, 59, 59, 999); // End of the day (23:59:59.999)
        //         return bookingDate >= startDate && bookingDate <= endDate;
        //     });
        // } else if (filters.dateRange !== 'all') {
        //     const now = new Date();
        //     let startDate = new Date();

        //     switch (filters.dateRange) {
        //         case 'today':
        //             startDate.setHours(0, 0, 0, 0);
        //             break;
        //         case 'week':
        //             startDate.setDate(now.getDate() - 7);
        //             break;
        //         case 'month':
        //             startDate.setMonth(now.getMonth() - 1);
        //             break;
        //         default:
        //             break;
        //     }

        //     result = result.filter(item => {
        //         const bookingDate = new Date(item.bookingDate);
        //         return bookingDate >= startDate;
        //     });
        // }

        if (filters.dateRange === 'custom' && filters.startDate && filters.endDate) {
          const start = moment(filters.startDate).startOf('day');
          const end = moment(filters.endDate).endOf('day');
        
          result = result.filter(i => {
            const showDate = moment(i.showDate, "YYYY/MM/DD"); // Parse with correct format
            return showDate.isBetween(start, end, undefined, '[]'); // inclusive
          });
        } else if (filters.dateRange !== 'all') {
          const now = moment();
          const start = moment();
        
          if (filters.dateRange === 'today') {
            start.startOf('day');
          } else if (filters.dateRange === 'yesterday') {
            start.subtract(1, 'day').startOf('day');
          } else if (filters.dateRange === 'week') {
            start.subtract(7, 'days').startOf('day');
          } else if (filters.dateRange === 'month') {
            start.subtract(1, 'month').startOf('day');
          }
        
          result = result.filter(i => {
            const showDate = moment(i.showDate, "YYYY/MM/DD"); // Parse with correct format
            if (filters.dateRange === 'today') {
              return showDate.isSame(moment(), 'day'); // Only today, no future dates
            } else if (filters.dateRange === 'yesterday') {
              return showDate.isSame(start, 'day'); // Only yesterday
            } else {
              return showDate.isSameOrAfter(start, 'day'); // Week/month: from X days ago onward
            }
          });
        }


        if (filters.theatreName !== 'all') {
          result = result.filter(item => item.theatreName === filters.theatreName);
        }

        setFilteredData(result);
    };



  const clearFilters = () => {
    setFilters({
      paymentMode: 'all',
      transactionStatus: 'all',
      dateRange: 'all',
      startDate: '',
      endDate: '',
      theatreName: 'all'
    });
    setShowMatchedOnly(false);
    setMatchedTransactions([]);
    setData(originalData); // <- Reset the data back to original
  };
  

  const handleTicketTransactionsExtracted = (transactionsFromFile) => {
    const matches = filteredData.filter(existingItem => {
      const existingTransactionId = existingItem.transactionId?.toString();
      return transactionsFromFile.some(fileItem => (
        existingTransactionId === fileItem['Merchant Reference Id']?.toString() ||
        existingTransactionId === fileItem['PhonePe Reference Id']?.toString() ||
        existingTransactionId === fileItem['PhonePe Transaction Reference Id']?.toString() ||
        existingTransactionId === fileItem['PhonePe Attempt Reference Id']?.toString() ||
        existingTransactionId === fileItem['Merchant Order Id']?.toString()
      ));
    });
    setMatchedTransactions(matches);
    setShowMatchedOnly(true);
    setFilteredData(matches);
    alert(`Found ${matches.length} matching transactions within the current filters`);
  };

  const toggleShowMatchedOnly = () => {
    setShowMatchedOnly(!showMatchedOnly);
    if (!showMatchedOnly) setFilteredData(matchedTransactions);
    else applyFilters();
  };

  // const generateExcel = () => {
  //   try {
  //     const selectedBankDetails = banks.find(bank => bank.bankName === selectedBank);
  //     if (!selectedBankDetails) {
  //       alert("Please select a valid bank.");
  //       return;
  //     }

  //     const dataToExport = filteredData.map(booking => ({
  //       Date: formatToIST(booking.bookingDate),
  //       BookingId: booking.bookingId,
  //       Amount: booking.theatrePayable || 0,
  //       PaymentMode: booking.paymentMode || "N/A",
  //       TransactionStatus: booking.transactionStatus || "N/A",
  //       TransactionId: booking.transactionId || "N/A",
  //       TheatreName: booking.theatreName || "",
  //       BaseAmount: booking.theatreBaseAmount || 0,
  //       GstAmount: booking.theatreGstAmount || 0,
  //       PlatformFee: booking.platformFee || 0,
  //       PlatformGst: booking.platformGst || 0,
  //       GatewayCharges: booking.gatewayCharges || 0,
  //       PlatformEarnings: booking.platformEarnings || 0
  //     }));

  //     const ws = XLSX.utils.json_to_sheet(dataToExport);
  //     const wb = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, `${selectedBank}_Revenue`);
  //     XLSX.writeFile(wb, `${selectedBank}_Revenue_${new Date().toISOString().split('T')[0]}.xlsx`);

  //   } catch (error) {
  //     console.error("Error generating Excel file:", error);
  //     alert("Error generating Excel file. Please try again.");
  //   }
  // };







  const generateExcel = () => {
    try {
        const selectedBankDetails = banks.find(
            (bank) => bank.bankName === selectedBank
        );

        if (!selectedBankDetails) {
            alert("Please select a valid bank.");
            return;
        }

        const bankDetails = {
            "Bank Name": selectedBankDetails.bankName,
            "Account Number": selectedBankDetails.accountNumber,
            "IFSC Code": selectedBankDetails.ifscCode,
            "Account Type": selectedBankDetails.accountType,
        };

        // Always use selectedTheatreAccount if available
        if (!selectedTheatreAccount) {
            alert("Please select a beneficiary (theatre account).");
            return;
        }

        const theatreName = selectedTheatreAccount.theatreName || "Theatre Name Not Available";


        console.log('selected selectedTheatreAccount&&&&&&&&&&&&&&&&&&&&&&&&&',selectedTheatreAccount)


        

        const data = filteredData.map((booking) => ({
            Date: formatToIST(booking.bookingDate),
            BookingId: booking.bookingId,
            Amount: booking.theatrePayable || 0,
            PaymentMode: booking.paymentMode || "N/A",
            TransactionStatus: booking.transactionStatus || "N/A",
            TransactionId: booking.transactionId || "N/A",
            TheatreName: theatreName,
            TheatrePayable: booking.theatrePayable || 0,
            TheatreBaseAmount: booking.theatreBaseAmount || 0,
            TheatreGstAmount: booking.theatreGstAmount || 0,
        }));

        let formattedData;
        let headers;

        if (selectedBank === "ICICI Bank") {
            formattedData = data.map((item) => ({
                "Transaction Date": item.Date,
                "Transaction Ref No": item.BookingId,
                "Amount In INR": item.TheatrePayable,
                "Payment State": item.TransactionStatus,
                "Theatre Name": item.TheatreName,
                "Payment Mode": item.PaymentMode,
                "Transaction ID": item.TransactionId,
                "Base Amount": item.TheatreBaseAmount,
                "GST Amount": item.TheatreGstAmount,
                "Bank Name": bankDetails["Bank Name"],
                "Account Number": bankDetails["Account Number"],
                "IFSC Code": bankDetails["IFSC Code"],
                "Account Type": bankDetails["Account Type"],
                "Beneficiary Name": selectedTheatreAccount.beneficiaryName,
                "Beneficiary Account": selectedTheatreAccount.accountNumber,
                "Beneficiary IFSC": selectedTheatreAccount.ifscCode,
                "Beneficiary Bank": selectedTheatreAccount.bankName
            }));

            headers = [
                "Transaction Date",
                "Transaction Ref No",
                "Amount In INR",
                "Payment State",
                "Theatre Name",
                "Payment Mode",
                "Transaction ID",
                "Base Amount",
                "GST Amount",
                "Bank Name",
                "Account Number",
                "IFSC Code",
                "Account Type",
                "Beneficiary Name",
                "Beneficiary Account",
                "Beneficiary IFSC",
                "Beneficiary Bank"
            ];
        } else if (selectedBank === "Ujjivan Bank") {

          console.log('selected the Ujjivan Bank')
            formattedData = data.map((item) => ({
                Identifier: "NFT",
                "Unique reference number": item.BookingId,
                Amount: item.TheatrePayable,
                "Debit Account number": bankDetails["Account Number"],
                "Beneficiary Name": selectedTheatreAccount.beneficiaryName,
                "Beneficiary Address": "",
                "Beneficiary Account number": selectedTheatreAccount.accountNumber,
                "Beneficiary Bank IFSC code": selectedTheatreAccount.ifscCode,
                "Beneficiary Bank Name": selectedTheatreAccount.bankName,
                Remarks: "",
                LEI: "",
            }));

            headers = [
                "Identifier",
                "Unique reference number",
                "Amount",
                "Debit Account number",
                "Beneficiary Name",
                "Beneficiary Address",
                "Beneficiary Account number",
                "Beneficiary Bank IFSC code",
                "Beneficiary Bank Name",
                "Remarks",
                "LEI",
            ];
        } else {
            alert("Bank format not supported.");
            return;
        }

        const ws = XLSX.utils.json_to_sheet(formattedData, { header: headers });

        // Set column widths
        const colWidths = headers.map((header) => {
            let maxLength = header.length;
            formattedData.forEach((item) => {
                const cellLength = (item[header] || "").toString().length;
                if (cellLength > maxLength) maxLength = cellLength;
            });
            return { wch: maxLength + 2 };
        });

        ws["!cols"] = colWidths;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, `${selectedBank}_TheatrePayments`);
        XLSX.writeFile(wb, `${selectedBank}_TheatrePayments_${new Date().toISOString().split('T')[0]}.xlsx`);

    } catch (error) {
        console.error("Error generating Excel file:", error);
        alert("Error generating Excel file. Please try again.");
    }
};




  const totals = calculateRevenueTotals(filteredData);

  if (isLoading) return <div className="text-center py-8">Loading report...</div>;
  if (error) return <div className="text-center py-8 text-red-500">{error}</div>;

  return (
    <div className="max-w-full px-6 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Revenue Report</h1>
        <button
          onClick={toggleShowMatchedOnly}
          className={`px-4 py-2 rounded text-sm font-medium ${showMatchedOnly ? 'bg-green-600 text-white' : 'bg-gray-100 text-gray-700'}`}
        >
          {showMatchedOnly ? 'Show All' : 'Show Matched Only'}
        </button>
      </div>

      {/* <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Upload Statement
        </label>
        <UploadTicketStatement onTransactionsExtracted={handleTicketTransactionsExtracted} />
      </div> */}

      <RevenueFilters
        filters={filters}
        setFilters={setFilters}
        banks={banks}
        theatreAccounts={theatreAccounts}
        selectedBank={selectedBank}
        selectedTheatreAccount={selectedTheatreAccount}
        setSelectedBank={setSelectedBank}
        setSelectedTheatreAccount={setSelectedTheatreAccount}
        handleGenerateClick={handleGenerateClick}
        showBankSelector={showBankSelector}
        handleGenerateFile={handleGenerateFile}
        handleBankChange={handleBankChange}
        handleTicketTransactionsExtracted={handleTicketTransactionsExtracted}
        theatreOptions={getTheatreOptions(data)} // <-- Add this line
        paymentModeOptions={getPaymentModeOptions(data)} // <-- Add this
        transactionStatusOptions={getTransactionStatusOptions(data)} // <-- Add this
        clearFilters={clearFilters}
      />

      <RevenueSummaryCards totals={totals} />

      <RevenueTable data={paginatedData} />

      <PaginationControls
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />

      {/* <BankExportForm
        banks={banks}
        selectedBank={selectedBank}
        selectedTheatreAccount={selectedTheatreAccount}
        theatreAccounts={theatreAccounts}
        handleBankChange={handleBankChange}
        handleGenerateFile={handleGenerateFile}
        setSelectedTheatreAccount={setSelectedTheatreAccount}  // <-- add this
      /> */}
    </div>
  );
};

export default RevenueReport;








































